import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { Box, Grid } from '@mui/material';
import { useRef } from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { v4 } from 'uuid';
import { useReviewContext } from '../../Context';
import HeaderBand from './components/HeaderBand';
import ImageCta from './components/ImageCta';
import AlternatePickRating from './components/Rating';
import AlternatePickReadReviewCta from './components/ReadReviewCta';
import TitleCta from './components/TitleCta';
export default function AlternatePick() {
  const {
    alternatePicks
  } = useReviewContext();
  const firstAlternatePick = alternatePicks[0];
  const activityId = useRef(v4()).current;
  if (!firstAlternatePick) {
    return null;
  }
  const {
    description,
    label,
    marketplaceEntity,
    tagline
  } = firstAlternatePick;
  if (!marketplaceEntity || !marketplaceEntity.reviewLink) {
    return null;
  }
  const {
    ctaAnalytics,
    details: {
      isActive
    },
    image,
    name,
    reviewLink,
    starRating,
    starRatingTooltip
  } = marketplaceEntity;
  return <FeatureViewed entityName="alt_pick" entitySection="review" impressionPosition={0} activityId={activityId}>
      <AnalyticsSkuViewed id={marketplaceEntity.id} impressionPosition={0} impressionSection={`review-alternative-pick`} name={marketplaceEntity.name} monetizable={marketplaceEntity.details.monetizable}>
        <Grid container paddingX={4} paddingBottom={4} marginLeft={1} borderRadius="0.125rem" border={({
        palette
      }) => `1px solid ${palette.neutral.lighter}`} position="relative" data-testid="alternativePickComponent">
          {label && <HeaderBand label={label} />}
          <Grid container>
            {isActive && <Grid size={{
            xs: 12,
            md: 4
          }}>
                <Grid container direction="column" alignItems="center" height="100%" flexWrap={{
              xs: 'wrap',
              md: 'nowrap'
            }}>
                  <Grid size={12} display="flex" alignItems="center">
                    <ImageCta ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} image={image} parentActivityId={activityId} />
                  </Grid>
                  {starRating ? <Grid size={12}>
                      <AlternatePickRating ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} starRating={starRating} starRatingTooltip={starRatingTooltip} />
                    </Grid> : null}
                </Grid>
              </Grid>}
            <Grid size={{
            xs: 12,
            md: isActive ? 8 : 12
          }}>
              <Box paddingTop={{
              xs: 3,
              md: 0
            }}>
                <Grid size={12}>
                  <TitleCta ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} isActive={isActive} name={name} parentActivityId={activityId} />
                </Grid>
                {tagline && <Grid size={{
                xs: 12
              }} marginBottom={2} sx={{
                '& p': {
                  fontSize: '0.8125rem',
                  color: 'neutral.dark',
                  lineHeight: '1.5',
                  fontWeight: 'normal'
                }
              }} data-testid="alternate-pick-tagline">
                    <StructuredContentRenderer doc={tagline} />
                  </Grid>}
                {description && <Grid size={12} marginBottom={3} sx={{
                '& p': {
                  fontSize: '0.8125rem',
                  lineHeight: '1.5',
                  fontWeight: 'normal'
                }
              }} data-testid="alternate-pick-description">
                    <StructuredContentRenderer doc={description} />
                  </Grid>}
                {!isActive && starRating ? <Grid size={12} marginBottom={3}>
                    <AlternatePickRating ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} starRating={starRating} starRatingTooltip={starRatingTooltip} alignItems="flex-start" />
                  </Grid> : null}
                <Grid>
                  <AlternatePickReadReviewCta ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} parentActivityId={activityId} />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </AnalyticsSkuViewed>
    </FeatureViewed>;
}